
import { Header, ITableData } from '../../../../pricing-simulator/types/generic-table.model';
import { extractFieldsFromFormulae } from '../../../../pricing-simulator/utils/column-utils';
import { calculateValueFromFormula } from '../../../../pricing-simulator/utils/number-utils';
import flattenColumnsHeader from './flatten-headers';

const getValueByFormula = (data: any, formula: string, parentField: string) => {
    const fields = extractFieldsFromFormulae(formula);
    const selectChangedFormulaVal: number | string = calculateValueFromFormula(
        formula,
        data.parent.data,
        fields
    );
    if (!Number.isNaN(selectChangedFormulaVal)) {
        data.parent.data[parentField] = selectChangedFormulaVal;
    }
    return data;
};


const calculateFormulaVal = (
    flattenHeaders: Header[],
    comparingField: Header,
    currentField: Header,
    data
) => {
    flattenHeaders
        .filter((metadata) => metadata && metadata.parent.formula)
        .filter(
            (headerData) =>
                headerData.parent.parent_field !== comparingField?.parent?.parent_field &&
                extractFieldsFromFormulae(headerData.parent.formula).includes(
                    currentField?.parent?.parent_field
                ) &&
                data?.parent?.data[headerData.parent.parent_field] !== 'NAN'
        )
        .forEach((colHeaderData) => {
            data = getValueByFormula(
                data,
                colHeaderData.parent.formula,
                colHeaderData.parent.parent_field
            );
        });
    return data;
};

const calculateLinkedFieldVal = (
    flattenHeaders: Header[],
    comparingField: Header,
    currentField: Header,
    data,
    v
) => {
    if (data?.parent?.data && currentField?.parent?.parent_field && v?.linked_to_field) {
      data.parent.data[v.linked_to_field] =
          data.parent.data[currentField.parent.parent_field];
    }

    const dataForLinkedField = flattenHeaders.find(
        (metadata) =>
            metadata &&
            v.linked_to_field === metadata?.parent?.parent_field
    );
    if (
        dataForLinkedField &&
        dataForLinkedField.parent.self_change_formula
    ) {
        data = getValueByFormula(
            data,
            dataForLinkedField.parent.self_change_formula,
            dataForLinkedField.parent.parent_field
        );
    }
    data = calculateFormulaVal(
        flattenHeaders,
        comparingField,
        dataForLinkedField,
        data
    );
}

export default function getUpdatedData(data: { [key: string]: any }, columnMetadata: Header, tableMetaData: ITableData, newVal?: number) {
    if (newVal !== undefined && data?.parent?.data && columnMetadata?.parent?.parent_field) {
        data.parent.data[columnMetadata.parent.parent_field] = newVal;
    }
    if (columnMetadata?.parent?.self_change_formula) {
        data = getValueByFormula(
            data,
            columnMetadata.parent.self_change_formula,
            columnMetadata.parent.parent_field
        );
    }

    const flattenHeaders = flattenColumnsHeader(tableMetaData);
    flattenHeaders
        .filter((metadata) => metadata && metadata.parent.formula)
        .filter(
            (colData) =>
                (extractFieldsFromFormulae(colData.parent.formula).includes(
                    columnMetadata.parent.parent_field
                ) ||
                    (columnMetadata.parent.linked_to_fields
                        .map((v: any) => v.linked_to_field).includes(colData.parent.parent_field)
                        ||
                        colData.parent.parent_field === columnMetadata.parent.linked_to_field)
                ) &&
                data?.parent?.data[colData.parent.parent_field] !== 'NAN'
        )
        .forEach((colData, index) => {
            data = getValueByFormula(
                data,
                colData.parent.formula,
                colData.parent.parent_field
            );

            if (columnMetadata.parent.parent_field !== colData.parent.parent_field) {
                if (columnMetadata.parent.linked_to_fields.length) {
                    columnMetadata.parent.linked_to_fields.forEach((v: any) => {
                        calculateLinkedFieldVal(flattenHeaders, columnMetadata, columnMetadata, data, v);
                    })
                } else {
                    if (columnMetadata.parent.linked_to_field !== '') {
                        return calculateLinkedFieldVal(flattenHeaders, columnMetadata, columnMetadata, data, columnMetadata.parent);
                    }
                }
                if (colData.parent.linked_to_fields.length) {
                    colData.parent.linked_to_fields.forEach((v: any) => {
                        calculateLinkedFieldVal(flattenHeaders, columnMetadata, colData, data, v);
                    })
                } else {
                    if (colData.parent.linked_to_field !== '') {
                        return calculateLinkedFieldVal(flattenHeaders, columnMetadata, colData, data, colData.parent);
                    }
                }
            }
        });

        // Recalculate the edited field after all dependent formulas run,
        // so self_change_formula reads the latest values in this cycle.
        if (columnMetadata?.parent?.self_change_formula) {
            data = getValueByFormula(
                data,
                columnMetadata.parent.self_change_formula,
                columnMetadata.parent.parent_field
            );
        }

        if(data?.parent?.data){
          return {
              ...data.parent.data
          };
        } else {
          console.warn("data.parent.data is undefined, returning empty object");
          return {};
        }
};